import { DataRefineryConfig } from "../domainObjects/dataRefineryConfig";

export class RefineryViewModel {
  nodeWidth: number;
  nodeHeightRatio_Per: number;
  nodeHeight:number;
  nodeGearSizePX: number;
  dataWriterSize_Per:number;
  dataWriterSizePX:number;
  nodeGearSize_Per: number;
  gearPosition_X: number;
  gearPosition_Y:number;
  nodePadding_X:number;
  nodePadding_Y:number;
  nodeBorderWeight:number;
  nodeBorderStroke:number;
  nodeFontSizeTitle:number;
  nodeFontSizeSubtitle:number;
  nodeFontSizeFarmType:number;
  nodeFontSizeStatus:number;
  nodeFontSizeTitlePer:number;
  nodeFontSizeSubtitlePer:number;
  nodeFontSizeFarmTypePer:number;
  nodeFontSizeStatusPer:number;
  nodeMenuFontSizePer:number;
  menuFontSizePX:number;
  dataRefineryConfig: DataRefineryConfig;
  titlePadXPer:number;
  titlePadYPer:number;
  subTitlePadXPer:number;
  subTitlePadYPer:number;
  nodeIDPadXPer:number;
  nodeIDPadYPer:number;

  constructor(
     nodeWidth: number
    ,nodeHeightRatio_Per: number
    ,_nodeHeight: number
    ,_nodeGearSizePX: number
    ,DatawriterSize_Per: number
    ,_DatawriterSizePX: number
    ,nodeGearSize_Per: number
    ,gearPosition_X: number
    ,gearPosition_Y: number
    ,nodePadding_X: number
    ,nodePadding_Y: number
    ,nodeBorderWeight: number
    ,_nodeBorderStroke: number
    ,_nodeFontSizeTitle: number
    ,_nodeFontSizeSubtitle: number
    ,_nodeFontSizeFarmType: number
    ,_nodeFontSizeStatus: number
    ,nodeFontSizeTitlePer: number
    ,nodeFontSizeSubtitlePer: number
    ,nodeFontSizeFarmTypePer: number
    ,nodeFontSizeStatusPer: number
    ,nodeMenuFontSizePer: number
    ,_MenuFontSizePX: number
    ,dataRefineryConfig: DataRefineryConfig
    ,titlePadXPer: number
    ,titlePadYPer: number
    ,SubTitlePadXPer: number
    ,SubTitlePadYPer: number
    ,NodeIDPadXPer: number
    ,NodeIDPadYPer: number
    ) {

    this.nodeWidth = nodeWidth;
    this.nodeHeightRatio_Per = nodeHeightRatio_Per;
    this.nodeHeight = Math.round(this.nodeWidth * (this.nodeHeightRatio_Per / 100));
    this.dataWriterSize_Per = DatawriterSize_Per;
    this.nodeGearSize_Per = nodeGearSize_Per;
    this.nodeGearSizePX = Math.round(this.nodeHeight * (this.nodeGearSize_Per / 100));
    this.dataWriterSizePX = Math.round(this.nodeHeight * (this.dataWriterSize_Per / 100));
    this.nodeMenuFontSizePer = nodeMenuFontSizePer;
    this.menuFontSizePX = Math.round(this.nodeHeight * (this.nodeMenuFontSizePer / 100));
    this.gearPosition_X = gearPosition_X;
    this.gearPosition_Y = gearPosition_Y;
    this.nodePadding_X = nodePadding_X;
    this.nodePadding_Y = nodePadding_Y;
    this.nodeBorderWeight = nodeBorderWeight;
    this.nodeFontSizeTitlePer = nodeFontSizeTitlePer;
    this.nodeFontSizeSubtitlePer = nodeFontSizeSubtitlePer;
    this.nodeFontSizeFarmTypePer = nodeFontSizeFarmTypePer;
    this.nodeFontSizeStatusPer = nodeFontSizeStatusPer;
    this.nodeBorderStroke = Math.round(this.nodeHeight / 200 * this.nodeBorderWeight);
    this.nodeFontSizeTitle = Math.round(this.nodeWidth * (this.nodeHeightRatio_Per / 100) * nodeFontSizeTitlePer / 100);
    this.nodeFontSizeSubtitle = Math.round(this.nodeWidth * (this.nodeHeightRatio_Per / 100) * nodeFontSizeSubtitlePer / 100);
    this.nodeFontSizeFarmType = Math.round(this.nodeWidth * (this.nodeHeightRatio_Per / 100) * nodeFontSizeFarmTypePer / 100);
    this.nodeFontSizeStatus = Math.round(this.nodeWidth * (this.nodeHeightRatio_Per / 100) * nodeFontSizeStatusPer / 100);
    this.dataRefineryConfig = dataRefineryConfig;
    this.titlePadXPer = titlePadXPer;
    this.titlePadYPer = titlePadYPer;
    this.subTitlePadXPer = SubTitlePadXPer;
    this.subTitlePadYPer = SubTitlePadYPer;
    this.nodeIDPadXPer = NodeIDPadXPer;
    this.nodeIDPadYPer = NodeIDPadYPer;
  }
}